/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateRelease} from '../api'

export const useMutationCreateOrUpdateRelease = createReactQueryMutationHook('createOrUpdateRelease', createOrUpdateRelease)
